import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

interface SharedDetailAccordionProps {
  index: string;
  title: string;
  detail?: React.ReactNode;
  subDetail?: React.ReactNode;
}

export default function SharedDetailAccordion({
  index,
  title,
  detail,
  subDetail,
}: SharedDetailAccordionProps) {
  const theme = useTheme();

  return (
    <Accordion
      key={index}
      sx={{
        border: '0px',
        width: 'fit-content',
        background: 'transparent',
        color: theme.palette.text.secondary,
        '& .MuiAccordion-heading': {
          minHeight: 35,
          '& .MuiButtonBase-root': {
            minHeight: 35,
            '& .MuiAccordionSummary-content': {
              m: 0,
            },
          },
        },
        '&::before': {
          display: 'none',
        },
        mt: 1,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          background: 'transparent',
          width: 'auto',
          m: 0,
        }}
      >
        <Typography variant="body2">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Stack
          sx={{
            ml: 4,
            mt: 0,
            display: 'inline-block',
          }}
        >
          <Typography variant="body2">
            {detail ? detail : null}
            {subDetail ? subDetail : null}
          </Typography>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
